import React, { FunctionComponent } from 'react';

import { useUnit } from 'effector-react/ssr';

import clsx from 'clsx';

import {
    $confirmDialog,
    ConfirmDialogDescriptionColor,
    ConfirmDialogDescriptionMarginTop,
    resetConfirmDialog,
} from '@stores/dialogs/confirm';

import { isValueSet } from '@utils/guards';

import { Button } from '@components/common/Button/Button';
import { Dialog } from '@components/common/Dialog/Dialog';

import styles from './ConfirmDialog.module.scss';

const descriptionColorClassMap: Record<ConfirmDialogDescriptionColor, string> = {
    gray: styles.isGrayColor,
    black: styles.isBlackColor,
};

const descriptionMarginTopClassMap: Record<ConfirmDialogDescriptionMarginTop, string> = {
    8: styles.isSmallMarginTop,
    32: styles.isLargeMarginTop,
};

export const ConfirmDialog: FunctionComponent = () => {
    const [{ isOpen, options }, resetConfirmDialogFn] = useUnit([
        $confirmDialog,
        resetConfirmDialog,
    ]);
    const { title, description, applyButton, disagreeButtonText, isLoading } = options;

    const onClose = () => resetConfirmDialogFn();

    return (
        <Dialog
            isOpen={isOpen}
            setOpen={onClose}
            title={title}
            classes={{ content: styles.dialogContent }}
        >
            {isValueSet(description) && (
                <p
                    className={clsx(
                        styles.description,
                        descriptionColorClassMap[description.color],
                        descriptionMarginTopClassMap[description.marginTop],
                    )}
                >
                    {description.text}
                </p>
            )}

            <div className={styles.footer}>
                <Button
                    type="button"
                    variant={applyButton.variant}
                    onClick={applyButton.onClick}
                    isLoading={isLoading}
                    isFullWith
                >
                    {applyButton.text}
                </Button>
                <Button type="button" variant="white" onClick={onClose} isFullWith>
                    {disagreeButtonText}
                </Button>
            </div>
        </Dialog>
    );
};
